export default "__VITE_ASSET__9IyhVfJX__"